import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Station } from '@paragon/contract-library';

interface StationsState {
  status: 'loading' | 'loaded' | 'catastrophicallyFailed';

  stations: Record<string, Station>;

  /** Tracks what stations have been fully loaded (with component designs). */
  fullyLoadedStations: Record<string, true>;
}

const initialState: StationsState = {
  status: 'loading',
  stations: {},
  fullyLoadedStations: {},
};

export const stationsSlice = createSlice({
  name: 'stations',
  initialState,
  reducers: {
    // DANGER: This action is for synchronization and can be dispatched by other clients and the design service. Do not
    //   rename or modify the payload signature unless you know what you're doing.
    loadStation: (state, action: PayloadAction<{ station: Station; setAsActive?: boolean }>) => {
      state.stations[action.payload.station.guid] = action.payload.station;
      state.fullyLoadedStations[action.payload.station.guid] = true;
    },

    loadedFromServer(state, action: PayloadAction<{ stations: Station[]; shallow: boolean }>) {
      state.status = 'loaded';

      for (const station of action.payload.stations) {
        state.stations[station.guid] = station;
      }

      if (action.payload.shallow === false) {
        for (const station of action.payload.stations) {
          state.fullyLoadedStations[station.guid] = true;
        }
      }
    },

    loadingCatastrophicallyFailed(state) {
      state.status = 'catastrophicallyFailed';
    },

    singleStationCreated(state, action: PayloadAction<{ station: Station; parentGuid?: string }>) {
      state.stations[action.payload.station.guid] = action.payload.station;
    },

    singleStationEdited(state, action: PayloadAction<Station>) {
      state.stations[action.payload.guid] = action.payload;
    },

    singleStationDeleted(state, action: PayloadAction<{ guid: string }>) {
      delete state.stations[action.payload.guid];
    },
  },
});
